export const faqList = [
  {
    id: 'q1',
    q: '这个页面主要提供什么内容？',
    a: '这是一个围绕主题的资讯整理页，把新片、最新动态、消息、写真、活动与近况按分区汇总，方便在一个页面里按方向核对与浏览。',
  },
  {
    id: 'q2',
    q: '「新片」和「作品年表」有什么区别？',
    a: '新片速览偏向近期公开方向的快速了解，按题材分类；作品年表更强调时间与风格脉络，适合系统性地看整体变化。',
  },
  {
    id: 'q3',
    q: '写真合集的分类依据是什么？',
    a: '主要按色调、场景与质感划分，例如柔光、暖调外景、金调质感与暗调氛围，方便按视觉偏好挑选，而不是严格按照时间排序。',
  },
  {
    id: 'q4',
    q: '活动信息是最终安排吗？',
    a: '活动区为分类归档的整理信息，用于说明方向与参与方式，具体时间、地点与报名细则请以主办方或官方渠道公布为准。',
  },
  {
    id: 'q5',
    q: '怎样判断一条消息是否可靠？',
    a: '优先看是否来自官方账号或受认可的公开渠道，注意区分原文发布与二次转述，遇到只截取片段、缺少出处的内容建议先保留判断。',
  },
  {
    id: 'q6',
    q: '页面会持续更新吗？',
    a: '会按整理节奏更新，更新以新增条目与分类调整为主，尽量保持各分区口径一致，避免同一内容重复出现。',
  },
  {
    id: 'q7',
    q: '为什么部分条目写得比较概括？',
    a: '涉及具体时间、场次等信息时，为避免与实际情况出现偏差，页面采用一般性说明，并提示以官方发布为准，方便你在核对时保持谨慎。',
  },
  {
    id: 'q8',
    q: '在手机上浏览方便吗？',
    a: '页面针对桌面与移动端都做了适配，密集内容在手机上会以单列呈现，筛选、切换与展开等控件都支持触摸与键盘操作。',
  },
];